(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/tickets-table/components/ticket-item.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/tickets-table/components/ticket-item.js');
"use strict";


const Input = svs.ui.form.Input;
const _svs$ui$reactTable = svs.ui.reactTable,
  TableCell = _svs$ui$reactTable.TableCell,
  TableRow = _svs$ui$reactTable.TableRow;
const Brand = svs.ui.ReactBrand;
const TicketItem = _ref => {
  let article = _ref.article,
    handleOnChange = _ref.handleOnChange,
    handleOnBlur = _ref.handleOnBlur,
    isEditable = _ref.isEditable,
    articleCount = _ref.articleCount,
    maximumCount = _ref.maximumCount;
  const total = (parseInt(articleCount, 10) || 0) * article.price;
  return React.createElement(TableRow, {
    "data-testid": "ticket-row"
  }, React.createElement(TableCell, null, React.createElement("span", null, React.createElement(Brand, {
    brand: article.iconId,
    class: "margin-right-1 brand-icon",
    square: true
  }), article.ticketTitle)), React.createElement(TableCell, null, article.price), React.createElement(TableCell, null, isEditable ? React.createElement(Input, {
    "aria-label": "Ange antal produkter",
    className: "ticket-item-input-count",
    "data-testid": article.ticketTitle,
    max: maximumCount,
    min: "0",
    name: article.ticketTitle,
    onBlur: e => handleOnBlur(e, article),
    onChange: e => handleOnChange(e, article),
    type: "number",
    value: articleCount || ''
  }) : React.createElement("span", null, articleCount)), React.createElement(TableCell, null, svs.utils.format.Currency(total), "\xA0 kr"));
};
svs.ticket_partner.sharedComponents.ticketsTable.components.TicketItem = TicketItem;

 })(window);